import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'

import {getLogSummaryList} from '../../../apis/backendlogs/getLogsList'

const useQueryLotLogs = (size: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.logSummary.getLogSummaryList(),
        queryFn: async () => {
            const {data} = await getLogSummaryList(size)
            return data
        },
    })

    return {data, refetch}
}

export default useQueryLotLogs
